import type { OptionTs } from "@ps-bridge/interop";
import * as Option from "@utils/Option";

export const nowEpochSeconds = (): number => Math.floor(Date.now() / 1000);

export const normalizeStoredRefreshTimestampSeconds = (rawValue: string): OptionTs<number> => {
  const parsed = Number(rawValue);
  if (!Number.isFinite(parsed)) {
    return Option.none<number>();
  }
  // Backward compatibility: previous builds persisted millisecond timestamps.
  if (parsed > 10_000_000_000) {
    return Option.some(Math.floor(parsed / 1000));
  }
  return Option.some(Math.floor(parsed));
};
